import { Box, Flex } from '@chakra-ui/react';
import { ErrorMessage, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';

import {
  addDataStepOneFormMultipleDataPeriod,
  handleActionStepNext,
  resetDataPeriodValuesForMultipleType,
} from 'redux/DataImportSlice';
import { ActionDataStepTwoSchemaTimePeriod } from 'validation/schemas/ActionStepSchema';
import TableRowIcon from 'components/Icons/TableRowIcon';
import TableColumnIcon from 'components/Icons/TableColumnIcon';

import ActionStepFooter from '../../ActionStepFooter';
import {
  FieldError,
  FieldLabel,
  RadioDot,
  StepFooterRow,
  optionCardStyle,
} from '../../actionStepUi';

interface Properties {
  setHelpModalSeleceted: any;
  getFormValue: any;
}

const Multiple = ({ getFormValue }: Properties) => {
  const dispatch: any = useDispatch();
  const handleSubmit = async (form: any, setSubmitting: (data: boolean) => void) => {
    await dispatch(addDataStepOneFormMultipleDataPeriod(form)).then(() => {
      if (getFormValue?.dataPeriod === '2') {
        dispatch(resetDataPeriodValuesForMultipleType());
      }
      setSubmitting(false);
      dispatch(handleActionStepNext());
    });
  };
  return (
    <Formik
      initialValues={{
        selectedTimePeriod: '' || `${getFormValue.selectedTimePeriod}`,
      }}
      validationSchema={ActionDataStepTwoSchemaTimePeriod}
      onSubmit={(form, { setSubmitting }) => handleSubmit(form, setSubmitting)}
      enableReinitialize={true}
    >
      {({ values, isSubmitting, setFieldValue }: any) => (
        <Form style={{ width: '100%' }}>
          <Box mt={4}>
            <FieldLabel>Are the time periods in rows or columns?</FieldLabel>
            <Flex direction='column' gap={2}>
              {[
                { value: 'row', label: 'Select rows', illustration: <TableRowIcon /> },
                { value: 'column', label: 'Select columns', illustration: <TableColumnIcon /> },
              ].map((option) => {
                const isSelected = values.selectedTimePeriod === option.value;
                return (
                  <Flex
                    key={option.value}
                    as='button'
                    type='button'
                    role='radio'
                    aria-checked={isSelected}
                    {...optionCardStyle(isSelected)}
                    direction='column'
                    alignItems='flex-start'
                    onClick={() => setFieldValue('selectedTimePeriod', option.value)}
                  >
                    <Flex alignItems='center' gap={2}>
                      <RadioDot isSelected={isSelected} />
                      {option.label}
                    </Flex>
                    <Box w='100%' sx={{ svg: { width: '100%', height: 'auto' } }}>
                      {option.illustration}
                    </Box>
                  </Flex>
                );
              })}
            </Flex>
            <ErrorMessage name='selectedTimePeriod' component={FieldError} />
          </Box>

          <StepFooterRow>
            <ActionStepFooter
              nextButtonName='Continue'
              prevButtonName='Previous'
              isSubmitting={isSubmitting}
            />
          </StepFooterRow>
        </Form>
      )}
    </Formik>
  );
};

export default Multiple;
